import { getCurrentOrgId, isOrgUiEnabled } from '@thoughtspot/session-service';
import { CONTEXT } from '../settings/common';
export const getViewMode = (currentOrgId) => {
    if (isOrgUiEnabled() && getCurrentOrgId() === 0) {
        if (currentOrgId === -1) {
            return CONTEXT.ALL.view_mode;
        }
        if (currentOrgId === 0) {
            return CONTEXT.PRIMARY.view_mode;
        }
    }
    return CONTEXT.NONE.view_mode;
};
export const getEnabledConnectorIds = (connectors) => {
    return connectors.filter(({ enabled }) => enabled).map(({ id }) => id);
};
export const hasChanges = (before, after) => {
    if (before.length !== after.length)
        return true;
    if (before.length === 0)
        return false;
    const beforeSet = new Set(before);
    for (let i = 0; i < after.length; i++) {
        if (!beforeSet.has(after[i]))
            return true;
    }
    return false;
};
//# sourceMappingURL=csv-upload.util.js.map